import React, { useEffect } from 'react'
import { resolveThemeMode, ThemeMode } from '../lib/themeMode'
import { useSettings } from '../stateData/settings'
import { useTheme } from './useTheme'
import { useSignupSession } from './useSignupSession'

export const useResolvedThemeMode = (): ThemeMode => {
  const settingsState = useSettings()
  const theme = useTheme()
  const { isHpx } = useSignupSession()

  const { enableDarkModeHpx, enableDarkModeWeb, forcedThemeModeEnrollment } =
    settingsState?.data || {}

  const matchMediaMode = () => {
    if (globalThis?.matchMedia?.('(prefers-color-scheme: dark)')?.matches) {
      return 'dark'
    }

    return 'light'
  }

  const darkModeEnabled = isHpx ? enableDarkModeHpx : enableDarkModeWeb

  const appThemeMode = theme?.getUserThemeMode() ?? matchMediaMode()
  const resolvedMode = resolveThemeMode(
    darkModeEnabled,
    appThemeMode,
    forcedThemeModeEnrollment as ThemeMode
  )
  const isStyleguide = !!(globalThis as Record<string, unknown>).__STYLEGUIDE__

  const getStyleguideMode = (): ThemeMode | null => {
    const mode = sessionStorage.getItem('styleguide-theme')
    return mode === 'dark' || mode === 'light' ? mode : null
  }

  const [styleguideMode, setStyleguideMode] = React.useState<ThemeMode | null>(
    () => (isStyleguide ? getStyleguideMode() : null)
  )

  useEffect(() => {
    if (!isStyleguide) return

    const handler = () => {
      setStyleguideMode(getStyleguideMode())
    }

    globalThis.addEventListener('styleguide-theme-change', handler)

    return () => {
      globalThis.removeEventListener('styleguide-theme-change', handler)
    }
  }, [isStyleguide])

  if (isStyleguide && styleguideMode) {
    return styleguideMode
  }

  return resolvedMode
}
